module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/15ttoIy/tc-custom/9781459241411.jpg?1708752100458",
      "alt": "This image is the cover for the book Not Just the Greek's Wife"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Not Just the Greek's Wife\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Seeking to produce an heir to his empire, a man gets more than he bargained for in "), _c('i', [_vm._v("USA Today")]), _vm._v("–bestselling author Lucy Monroe’s "), _c('i', [_vm._v("Not Just the Greek’s Wife")]), _vm._v(".")]), _c('br'), _c('br'), _vm._v("Ariston Spiridakou had one reason and one reason only for marrying Chloe: he needed a biddable bride to provide the requisite heir. Yet three years later Chloe’s status as good Greek wife is a distant memory—and her defiance has had her cast out of Ariston’s life."), _c('br'), _c('br'), _vm._v("Infuriatingly, Chloe now finds herself at Ariston’s mercy—but his help comes with a wicked price: the unyielding condition that he won’t even consider her request until she’s shared his bed—and is expecting his baby!\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Lucy  Monroe\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("USA Today Bestseller Lucy Monroe finds inspiration for her stories everywhere as she is an avid people-watcher. She has published more than fifty books in several subgenres of romance and when she's not writing, Lucy likes to read.  She's an unashamed book geek, but loves movies and the theatre too. She adores her family and truly enjoys hearing from her readers! Visit her website at: http://lucymonroe.com")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0